<template>
    <div>
        <!--todo 未登入提醒-->
        <comm-dialog :value="isShowLogin"
                     :outerContent="'請先登入'"
                     @result="onShowLoginDialogClose"/>

        <!--todo 登入手勢下滑關閉--->
        <PullDownClose v-if="isShowPullDownLogin" @close="closePullDownLogin(false)" class="login-Pull">
            <Login class="content" isWeb @close="closePullDownLogin"/>
        </PullDownClose>
    </div>
</template>

<script>
    import CommDialog from "@/components/CommDialog";
    import Login from  "@/views/auth/Login"
    import PullDownClose from "@/components/PullDownClose";
    export default {
        name: "LoginWeb",
        props: {},
        components: {
            CommDialog,
            Login,
            PullDownClose,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
                //請先登入彈框
                isShowLogin: false,
                isShowPullDownLogin: false,
            }
        },
        created() {
            if(!this.isLogin){
                this.isShowLogin = true;
            }
        },
        mounted() {

        },
        methods: {
            //請先登入彈框關閉事件
            onShowLoginDialogClose(result){
                this.isShowLogin = false
                if (result) {
                    this.goLogin()
                }else {
                    this.$router.push('/web-store-info/'+this.$route.params.storeCode);
                }
            },

            //登入
            goLogin(){
                this.isShowPullDownLogin = true
            },

            //關閉下滑彈窗
            closePullDownLogin(result){
                if(result){
                    window.location.reload();
                }
                this.isShowLogin = !result;
                this.isShowPullDownLogin = false
            },
        }
    }
</script>

<style lang="less" scoped>
    .shop-item{
        @media(min-width: 1024px){
            margin: 5px -20px 0;
        }
    }
    .red{
        min-height: 40px;
    }
</style>